module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("e4tMK"))).then(() => parcelRequire('1iHdE'));